import React from 'react'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import {
  REACT_APP_FEATURE_FLAG_SUMMARY_SECTION,
  REACT_APP_FEATURE_FLAG_LINK_TO_OPEN_DATA_INFORMATION_SECTION,
  REACT_APP_FEATURE_FLAG_GENERAL_INFORMATION_TAB
} from '../../config/settings/environment'

/**
 * The ProtectByFeatures' component.
 */
const ProtectByFeatures = props => {
  const { children, fallback, redirectTo, rule } = props
  const navigate = useNavigate()

  const features = {
    'com.buyer/summary.section.public':
      REACT_APP_FEATURE_FLAG_SUMMARY_SECTION === true || REACT_APP_FEATURE_FLAG_SUMMARY_SECTION === 'true',
    'com.buyer/link.to.open.data.information':
      REACT_APP_FEATURE_FLAG_LINK_TO_OPEN_DATA_INFORMATION_SECTION === true ||
      REACT_APP_FEATURE_FLAG_LINK_TO_OPEN_DATA_INFORMATION_SECTION === 'true',
    'com.buyer/tab.general.information':
      REACT_APP_FEATURE_FLAG_GENERAL_INFORMATION_TAB === true ||
      REACT_APP_FEATURE_FLAG_GENERAL_INFORMATION_TAB === 'true'
  }
  const result = rule(features)

  if (!result && redirectTo) {
    navigate(redirectTo)
  }

  if (!result) {
    return fallback(features)
  }

  return <>{children}</>
}

ProtectByFeatures.defaultProps = {
  fallback: () => null,
  redirectTo: '',
  rule: () => true
}
ProtectByFeatures.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.func,
  redirectTo: PropTypes.string,
  rule: PropTypes.func
}

export default ProtectByFeatures
